import { composeClassNames } from "@faedev/editor-utils";
import { Alert } from "react-bootstrap";
import Text from "src/components/Text";
import gutter from "src/functions/gutter";
import { sAlert } from "src/styles/sAlert.module.scss";

export const Deadline = () => {
  return (
    <Alert
      variant={`info`}
      className={composeClassNames([sAlert])}
      style={gutter(`margin`, `top`, `lg`)}
    >
      <Text
        className={`festival-deadline`}
        size={`xn`}
        width={`semibold`}
      >{`Zakoupené lekce festivalu vám zůstanou i po jeho skončení.`}</Text>
    </Alert>
  );
};
